import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import toastMessage from "../../utils/toastMessage";
import { addEntityCategory } from "../../utils/queries/entityCategory";

class NewEntityCategory extends React.Component {
  state = {
    name: "",
    code: "",
    description: "",
    error: {},
    isSubmitting: false,
  };

  componentDidMount = () => {
    if (this.props._id) {
      this.setState({
        name: this.props.name || "",
        code: this.props.code || "",
        description: this.props.description || "",
      });
    }
  };

  onChangeText = (field, e) => {
    const inputValue = e?.target ? e.target.value : e;
    const { error } = this.state;
    delete error[field];

    this.setState({
      [field]: inputValue,
      error,
    });
  };

  validateForm = () => {
    const { name, code } = this.state;
    const error = {};

    if (!name || !name.trim()) {
      error.name = language[this.props.defaultLanguage].label_required;
    }
    if (!code || !code.trim()) {
      error.code = language[this.props.defaultLanguage].label_required;
    }

    this.setState({ error });
    return Object.keys(error).length === 0;
  };

  onSubmit = async () => {
    if (!this.validateForm()) return;

    try {
      this.setState({ isSubmitting: true });

      const payload = {
        name: this.state.name.trim(),
        code: this.state.code.trim(),
        description: this.state.description.trim(),
      };

      if (this.props._id) {
        payload.id = this.props._id;
      }

      await addEntityCategory(payload);

      toastMessage(
        "success",
        language[this.props.defaultLanguage][
          this.props._id ? "update_data_success" : "add_data_success"
        ]
      );

      this.setState({ isSubmitting: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            <Input
              label={language[this.props.defaultLanguage].name}
              value={this.state.name}
              onChange={(e) => this.onChangeText("name", e)}
              error={this.state.error.name}
              required
            />
          </div>
          <div className="col-md-12">
            <Input
              label={language[this.props.defaultLanguage].code}
              value={this.state.code}
              onChange={(e) => this.onChangeText("code", e)}
              error={this.state.error.code}
              required
            />
          </div>
          <div className="col-md-12">
            <Input
              label={language[this.props.defaultLanguage].description}
              value={this.state.description}
              onChange={(e) => this.onChangeText("description", e)}
            />
          </div>
          <div className="modal-footer">
            <Button
              text={language[this.props.defaultLanguage].cancel}
              onPress={this.props.handleCloseModal}
              className="btn-default"
            />
            <Button
              text={language[this.props.defaultLanguage].save}
              onPress={this.onSubmit}
              isSubmitting={this.state.isSubmitting}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(NewEntityCategory);
